import { throttle } from '../utils';

const interactions = [];

const useInteractions = (delay = 2e3, max = 10) => {
  const interactionHandler = throttle((event) => {
    interactions.unshift({
      time: Date.now(),
      event,
    });

    if (interactions.length > max) {
      interactions.splice(max, interactions.length - max);
    }
  }, delay);
  document.addEventListener('DOMContentLoaded', interactionHandler, { once: true });
  document.addEventListener('mousedown', interactionHandler, true);
  document.addEventListener('touchstart', interactionHandler, true);
  document.addEventListener('keydown', interactionHandler, true);
  window.addEventListener('scroll', interactionHandler, { passive: true });
  return interactions;
};

export {
  useInteractions,
};
